module.exports = __webpack_public_path__ + "img/img7418.e605bd13.jpg";